export function formatterDate(date) {
  if (!date) return '';
  const dateAux = new Date(date);
  const isoDateString = dateAux.toISOString();
  const day = isoDateString.slice(8, 10);
  const month = isoDateString.slice(5, 7);
  const year = isoDateString.slice(0, 4);

  return `${day}/${month}/${year}`;
}
